<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-primary m-0" *ngIf="persona">
        <mat-toolbar-row
            fxFlex
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <span class="title dialog-title text-truncate" *ngIf="persona"
                >{{ persona.nombres }}, {{ persona.apellidos }}</span
            >
            <button
                style="float: right"
                mat-icon-button
                (click)="dialogRef.close()"
                aria-label="Close dialog"
            >
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <mat-dialog-content class="p-16 pb-0 m-0">
        
        <mat-tab-group dynamicHeight="true">
            <mat-tab [label]="etiquetas.identificacion">
                <div class="p-24">
                    
                    <app-identificacion-personal-apoyo
                        *ngIf="persona"
                        [persona]="persona"
                    ></app-identificacion-personal-apoyo>
                </div>
            </mat-tab>

            <mat-tab [label]="etiquetas.certificaciones">
                <div class="p-24">
                    <app-certificaciones
                        *ngIf="persona"
                        [puedeEditar]="false"
                        [rutContratista]="rutPersona"
                    ></app-certificaciones>
                </div>
            </mat-tab>

        </mat-tab-group>
    </mat-dialog-content>
    <mat-divider></mat-divider>
    <mat-dialog-actions
        class="m-0 p-16"
        fxLayout="row"
        fxLayoutAlign="end center"
    >
        <button mat-raised-button color="accent" mat-dialog-close>
            Cerrar
        </button>
    </mat-dialog-actions>
</div>